export enum DialogSizes {
  S = 'small',
  M = 'medium',
  L = 'large',
}
